<template>
  <div id="Profile">
    <v-row
      ><h2 class="ml-4">{{ isEdit ? "Edit Profile" : "Profile" }}</h2>
      <v-spacer></v-spacer>
      <v-btn class="mr-4" @click="submit" depressed color="primary">
        <v-icon left v-if="!isEdit"> mdi-pencil </v-icon>
        {{ !isEdit ? "Edit Profile" : "Back" }}
      </v-btn>
      <v-col cols="12">
        <EditProfile v-if="isEdit" :form-type="'Edit'" />
        <MainProfile v-else /> </v-col
    ></v-row>
  </div>
</template>

<script>
import MainProfile from "../components/profile-vendor/MainProfile.vue";
import EditProfile from "../components/VendorProfile/MainRegisterVendor.vue";
export default {
  name: "Profile",
  components: {
    MainProfile,
    EditProfile,
  },
  data: () => ({
    isEdit: false,
  }),
  methods: {
    submit() {
      if (!this.isEdit) {
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
    },
  },
};
</script>

<style></style>
